import {BaseApi} from '@/api/base-api';

class AuthApi extends BaseApi {
  private static readonly baseUrl: string = `https://api.searchatlas.com/api/token/`;

  public async login(email: string, password: string) {
    const response = await this.axiosWithoutAuth.post(AuthApi.baseUrl, {
      username: email,
      password: password,
    });
    return response.data;
  }
}

export default AuthApi;
